 
 
import { apiWrapper } from 'ccs-ui-components';
import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { saveMaintenanceSchema } from '../../../../dashboard/components/utility/schema-defs';
import { IMaintenanceRequestData } from '../../../models';
import { saveMaintenance } from '../../actions/actionType/schedule-maintenance/SaveMaintenanceTypes';
import {
  saveMaintenanceFailure,
  saveMaintenanceStart,
  saveMaintenanceSuccessful
} from '../../actions/sagaActions/schedule-maintenance/SaveMaintenanceSagaActions';
import {
  SaveMaintenanceFailurePayload,
  SaveMaintenanceRequest
} from '../../actions/types/schedule-maintenance/SaveMaintenanceTypes';

const url = `${process.env.REACT_APP_API_CONTROL_PLANE_BASE_URL}`;

/**
 * Call Get metric summary by API
 * @returns api response
 */

export async function callSaveMaintenanceApi(data: IMaintenanceRequestData) {
  if (data?.isEdit) {
    delete data.isEdit;
    return apiWrapper.put(
      `${url}/schedule-maintenance/${data.maintenanceName}`,
      data
    );
  }
  return apiWrapper.post(`${url}/schedule-maintenance`, data);
}

export function* saveMaintenanceApi({ requestObject }: SaveMaintenanceRequest) {
  yield put(saveMaintenanceStart());
  try {
    const { responseBody: data, isError, error } = yield call(callSaveMaintenanceApi, requestObject);

    if (isError) {
      throw error;
    }

    const apiResponse = saveMaintenanceSchema.validate(data, {
      abortEarly: true
    });
    if (apiResponse.error) {
      throw new Error('No Response');
    } else {
      yield put(saveMaintenanceSuccessful(data));
    }
  } catch (error: any) {
    const obj: SaveMaintenanceFailurePayload = {
      error: 'Unable to Save Maintenance'
    };
    yield put(saveMaintenanceFailure(obj));
  }
}
/**
 * Saga Effect to consider latest request
 */
export function* SaveMaintenanceSaga() {
  yield takeLatest(
    saveMaintenance.SAVE_MAINTENANCE_REQUEST,
    saveMaintenanceApi
  );
}

export const saveMaintenanceSaga = [fork(SaveMaintenanceSaga)];
